import { RestSchemas } from '@/contexts/QueryProvider'
import { ENDPOINTS } from '@/util'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useInvalidateTemplateActivityLogByIds } from '../useGetTemplateActivityLogByIds'
import { useInvalidateTemplatesSummary } from '../../useGetTemplatesSummary'
import { useInvalidateActivityLogByKeys } from '@/catalog-apps/components/component-library/DataTableComponent/RowActions/useGetActivityLogByKeys'

type TransitionUpdateResponse = RestSchemas['Messages.Templates.TTemplateActivity']

const postTransitionUpdate = async (formData: FormData) => {
  const token = JSON.parse(sessionStorage.getItem('token') || '')
  const response = await fetch(`${ENDPOINTS.LANDING}/templates_activity_log_transition_template`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return (await response.json()) as TransitionUpdateResponse
}

export function usePostTransitionUpdate({
  entityId,
  templateId,
  onSuccess,
}: {
  entityId: number
  templateId: number
  onSuccess?: () => void
}) {
  const invalidateActivityLogByIds = useInvalidateTemplateActivityLogByIds({ entityId, templateId })
  const invalidateActivityLogByKeys = useInvalidateActivityLogByKeys()
  const invalidateTemplatesSummary = useInvalidateTemplatesSummary()
  return useMutation({
    mutationFn: (variables: { formData: FormData }) => postTransitionUpdate(variables.formData),
    onSuccess: (_data) => {
      invalidateActivityLogByIds()
      invalidateActivityLogByKeys()
      invalidateTemplatesSummary()
      toast.success('Success')
      onSuccess?.()
    },
  })
}
